import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: grid;
  gap: 20px;
  height: 100%;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 300px), 1fr));
  grid-template-rows: auto auto 1fr;
  grid-template-areas:
    "Header Header Header"
    "CardPrimary CardSecondary CardTertiary"
    "Extrato Extrato Extrato";
  width: 100%;
  padding: 24px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
  }

  @media (max-width: 768px) {
    grid-template-areas:
      "Header"
      "CardPrimary"
      "CardSecondary"
      "CardTertiary"
      "Extrato";
    grid-template-columns: 1fr;
    padding: 16px;
  }
`;

export const BannerContainer = styled.div`
  grid-area: Header;
  width: 100%;
`;

export const ExtratoContainer = styled.div`
  grid-area: Extrato;
  width: 100%;
  overflow: auto;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 768px) {
    max-height: 400px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const ExtratoLink = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Subtitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${props => props.theme.colors.text};
  letter-spacing: -0.01em;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${props => props.theme.colors.primary};
  font-size: 13px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 8px;
  transition: background-color 150ms ease;

  &:hover {
    background-color: ${props => props.theme.colors.primary}10;
  }
`;

export const NoDataMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background-color: ${props => props.theme.colors.card};
  border-radius: 16px;
  border: 1px solid ${props => props.theme.colors.border_grey}30;
  color: ${props => props.theme.colors.grey_text};
  font-size: 14px;
  font-weight: 500;
`;

export const DateFilterContainer = styled.div`
  padding: 16px 20px;
  background-color: ${props => props.theme.colors.card};
  border-radius: 12px;
  border: 1px solid ${props => props.theme.colors.border_grey}30;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
`;
